import { NativeBiometric } from "capacitor-native-biometric";
import {  getConfig } from './config.js';


const GROUP_SEPARATOR = ' ';

export async function base64FromPath(path) {
    const response = await fetch(path);
    const blob = await response.blob();
    return base64FromBlob(blob);
}

export function base64FromBlob(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject('method did not return a string');
            }
        };
        reader.readAsDataURL(blob);
    });
}

export async function isBiometricSupported() {
  try {
    let result = await NativeBiometric.isAvailable();

    return result.isAvailable;
  } catch (error) {
    console.warn("Biometric check failed:", error.message);
    return false;
  }
}

export function clearBiometricDatas() {
    if (!isBiometricSupported()) {
        return false;
    }

    NativeBiometric.deleteCredentials({
        server: "mobileapi.matrixhu.com",
    });
}

export function uts() {
    return Math.floor(Date.now() / 1000);
}

export function contractDraftHasContent(datas) {
    if (datas == null || typeof datas != 'object') {
        return false;
    }
    const metaKeys = ['reservationId', 'currentReservationId', 'continueInMatrix', 'isSavedToMatrix', 'updated', 'localIdentityId', 'nameOfDraft', 'identityId', 'hash', 'onlyDraft'];
    return Object.keys(datas).some(function(key) {
        if (metaKeys.includes(key)) {
            return false;
        }
        const value = datas[key];
        if (value === null || value === undefined || value === '') {
            return false;
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        if (typeof value == 'object') {
            return Object.keys(value).length > 0;
        }
        return true;
    });
}

export function highLightRequired(form) {
    if (typeof form == 'undefined') {
        form = 'contractForm';
    }

    let config = getConfig();
    let fieldName = 'mandatoryFields';
    if(getSystemVersion() === 'pl') {
      fieldName = 'mandatoryFieldsPL';
    }
    let mandatoryFields = config[form][fieldName];
    let highLighted = {};

    Object.keys(mandatoryFields).map(function(field) {
        highLighted[field] = true;
    });

    return highLighted;
}

export function searchKey(key) {
    if (key == null) {
        return null;
    }

    let chars = [
        // Hungary
        ['á', 'a'],
        ['é', 'e'],
        ['í', 'i'],
        ['ó', 'o'],
        ['ö', 'o'],
        ['ő', 'o'],
        ['ú', 'u'],
        ['ü', 'u'],
        ['ű', 'u'],
    ];

    key = key.toLowerCase();

    chars.forEach((char) => {
        key = key.replace(new RegExp(char[0], 'g'), char[1]);
    });

    key = key
        .trim()
        .split(' ')
        .map((v) => v.trim())
        .filter((v) => v != "")
        .join(' ')
    ;

    return key;
}

export function format(inputVal) {
    if (!inputVal) {
        return '';
    }

    let outputValArray = inputVal.replaceAll(GROUP_SEPARATOR, '').split('');
    let outputVal = '';
    let x = 0;
    outputValArray.reverse().forEach(function(number1) {
        let number = parseInt(number1);
        if (!isNaN(number)) {
            x++;
            outputVal += number;
            if (x % 3 == 0 && x < outputValArray.length) {
                outputVal += GROUP_SEPARATOR;
            }
        }
    });

    return reverseString(outputVal);
}

export function phoneFormat(inputVal) {
    if (!inputVal) {
        return '';
    }

    let outputValArray = inputVal.replaceAll(GROUP_SEPARATOR, '').split('');
    let outputVal = '';
    let x = 0;
    outputValArray.reverse().forEach(function(number1) {
        let number = parseInt(number1);
        if (!isNaN(number)) {
            x++;
            outputVal += number;
            switch (x) {
                case 2:
                case 5:
                    outputVal += GROUP_SEPARATOR;
                    break;
            }
        }
    });

    return reverseString(outputVal);
}

export function unFormat(val) {
    if (!val) {
        return '';
    }
    val = val.replace(/^0+/, '');

    if (GROUP_SEPARATOR === ',') {
        return val.replace(/,/g, '');
    } else {
        return val.replace(/\./g, '');
    }
}

export function setThousandSeparatorEvent(root = document) {
    root.querySelectorAll('.thousand-separated').forEach(item => {
        item.addEventListener('input', () => {
            item.value = format(item.value);
        });
    });

    let elem1 = document.getElementById('propertyDatasDetailsChargesPrice');
    if (elem1 != null) {
        elem1.addEventListener('input', () => {
            this.value = format(this.value);
        });
    }
    
}

export function reverseString(str) {
    return str.split("").reverse().join("");
}

Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};

export function mt_rand(min, max) {
    if (min > max) {
        throw new Error('The minimum value cannot be greater than maximum value!');
    }
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function formatWithPoints(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function getDaysInCurrentMonth() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const lastDay = new Date(year, month + 1, 0).getDate();

    const days = [];
    for (let i = 1; i <= lastDay; i++) {
        days.push(i);
    }

    return days;
}

export function getMonthName() {
    const date = new Date();
    const month = date.toLocaleString('default', { month: 'long' });
    return month;
}

export function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
}

export function hexToRgb(hex) {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b];
}

export function calculateComplementaryColor(hexColor) {
    const rgbColor = hexToRgb(hexColor);
    const complementaryRgb = rgbColor.map(component => 255 - component);
    const complementaryHex = rgbToHex(complementaryRgb[0], complementaryRgb[1], complementaryRgb[2]);
    return complementaryHex;
}

export function md5(str) {
    //  discuss at: http://phpjs.org/functions/md5/
    // original by: Webtoolkit.info (http://www.webtoolkit.info/)
    // improved by: Michael White (http://getsprink.com)
    // improved by: Jack
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    //    input by: Brett Zamir (http://brett-zamir.me)
    // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    //  depends on: utf8_encode
    //   example 1: md5('Kevin van Zonneveld');
    //   returns 1: '6e658d4bfcb59cc13f96c14450ac40b9'
  
    let xl;
  
    let rotateLeft = function(lValue, iShiftBits) {
      return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    };
  
    let addUnsigned = function(lX, lY) {
      let lX4, lY4, lX8, lY8, lResult;
      lX8 = (lX & 0x80000000);
      lY8 = (lY & 0x80000000);
      lX4 = (lX & 0x40000000);
      lY4 = (lY & 0x40000000);
      lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
      if (lX4 & lY4) {
        return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
      }
      if (lX4 | lY4) {
        if (lResult & 0x40000000) {
          return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
        } else {
          return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
        }
      } else {
        return (lResult ^ lX8 ^ lY8);
      }
    };
  
    let _F = function(x, y, z) {
      return (x & y) | ((~x) & z);
    };
    let _G = function(x, y, z) {
      return (x & z) | (y & (~z));
    };
    let _H = function(x, y, z) {
      return (x ^ y ^ z);
    };
    let _I = function(x, y, z) {
      return (y ^ (x | (~z)));
    };
  
    let _FF = function(a, b, c, d, x, s, ac) {
      a = addUnsigned(a, addUnsigned(addUnsigned(_F(b, c, d), x), ac));
      return addUnsigned(rotateLeft(a, s), b);
    };
  
    let _GG = function(a, b, c, d, x, s, ac) {
      a = addUnsigned(a, addUnsigned(addUnsigned(_G(b, c, d), x), ac));
      return addUnsigned(rotateLeft(a, s), b);
    };
  
    let _HH = function(a, b, c, d, x, s, ac) {
      a = addUnsigned(a, addUnsigned(addUnsigned(_H(b, c, d), x), ac));
      return addUnsigned(rotateLeft(a, s), b);
    };
  
    let _II = function(a, b, c, d, x, s, ac) {
      a = addUnsigned(a, addUnsigned(addUnsigned(_I(b, c, d), x), ac));
      return addUnsigned(rotateLeft(a, s), b);
    };
  
    let convertToWordArray = function(str) {
      let lWordCount;
      let lMessageLength = str.length;
      let lNumberOfWords_temp1 = lMessageLength + 8;
      let lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
      let lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
      let lWordArray = new Array(lNumberOfWords - 1);
      let lBytePosition = 0;
      let lByteCount = 0;
      while (lByteCount < lMessageLength) {
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = (lWordArray[lWordCount] | (str.charCodeAt(lByteCount) << lBytePosition));
        lByteCount++;
      }
      lWordCount = (lByteCount - (lByteCount % 4)) / 4;
      lBytePosition = (lByteCount % 4) * 8;
      lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
      lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
      lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
      return lWordArray;
    };
  
    let wordToHex = function(lValue) {
      let wordToHexValue = '',
        wordToHexValue_temp = '',
        lByte, lCount;
      for (lCount = 0; lCount <= 3; lCount++) {
        lByte = (lValue >>> (lCount * 8)) & 255;
        wordToHexValue_temp = '0' + lByte.toString(16);
        wordToHexValue = wordToHexValue + wordToHexValue_temp.substr(wordToHexValue_temp.length - 2, 2);
      }
      return wordToHexValue;
    };
  
    let x = [],
      k, AA, BB, CC, DD, a, b, c, d, S11 = 7,
      S12 = 12,
      S13 = 17,
      S14 = 22,
      S21 = 5,
      S22 = 9,
      S23 = 14,
      S24 = 20,
      S31 = 4,
      S32 = 11,
      S33 = 16,
      S34 = 23,
      S41 = 6,
      S42 = 10,
      S43 = 15,
      S44 = 21;
  
    //str = this.utf8_encode(str);
    x = convertToWordArray(str);
    a = 0x67452301;
    b = 0xEFCDAB89;
    c = 0x98BADCFE;
    d = 0x10325476;
  
    xl = x.length;
    for (k = 0; k < xl; k += 16) {
      AA = a;
      BB = b;
      CC = c;
      DD = d;
      a = _FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
      d = _FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
      c = _FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
      b = _FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
      a = _FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
      d = _FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
      c = _FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
      b = _FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
      a = _FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
      d = _FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
      c = _FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
      b = _FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
      a = _FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
      d = _FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
      c = _FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
      b = _FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
      a = _GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
      d = _GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
      c = _GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
      b = _GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
      a = _GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
      d = _GG(d, a, b, c, x[k + 10], S22, 0x2441453);
      c = _GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
      b = _GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
      a = _GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
      d = _GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
      c = _GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
      b = _GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
      a = _GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
      d = _GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
      c = _GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
      b = _GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
      a = _HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
      d = _HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
      c = _HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
      b = _HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
      a = _HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
      d = _HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
      c = _HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
      b = _HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
      a = _HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
      d = _HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
      c = _HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
      b = _HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
      a = _HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
      d = _HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
      c = _HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
      b = _HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
      a = _II(a, b, c, d, x[k + 0], S41, 0xF4292244);
      d = _II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
      c = _II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
      b = _II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
      a = _II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
      d = _II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
      c = _II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
      b = _II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
      a = _II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
      d = _II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
      c = _II(c, d, a, b, x[k + 6], S43, 0xA3014314);
      b = _II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
      a = _II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
      d = _II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
      c = _II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
      b = _II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
      a = addUnsigned(a, AA);
      b = addUnsigned(b, BB);
      c = addUnsigned(c, CC);
      d = addUnsigned(d, DD);
    }
  
    let temp = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
  
    return temp.toLowerCase();
  }

export function isArraysEqual(array1, array2) {
    if (typeof array1 == 'undefined' || array1 == null || typeof array1 != 'object') {
        return false;
    }
    if (typeof array2 == 'undefined' || array2 == null || typeof array2 != 'object') {
        return false;
    }

    const str1 = md5(JSON.stringify(array1));
    const str2 = md5(JSON.stringify(array2));

    return str1 === str2;
}

export function getElementOffsetTop(id) {
    return window.scrollY + document.getElementById(id).getBoundingClientRect().top;
}

export function getWinowHeight() {
    return window.window.innerHeight;
}

export function isEmpty(value) {
    if (['', null].includes(value)) {
        return true;
    }

    return false;
}

export function animateHeight(startHeight, endHeight, element, callbefore, callback) {
    if (typeof callbefore == 'function') {
        callbefore();
    }

    const duration = 300;
    const interval = 10;
    const steps = duration / interval;
    const heightIncrement = (endHeight - startHeight) / steps;
    let currentHeight = startHeight;

    const animate = () => {
    if ((heightIncrement > 0 && currentHeight < endHeight) || (heightIncrement < 0 && currentHeight > endHeight)) {
            currentHeight += heightIncrement;
            element.style.height = currentHeight + "px";
            setTimeout(animate, interval);
        }
    };

    animate();

    if (typeof callback == 'function') {
        callback();
    }
}

export function getToken() {
    let token = '';
    const loginDatas = JSON.parse(localStorage.getItem('loginDatas'));
    if (loginDatas != null && typeof loginDatas.token != 'undefined') {
        token = loginDatas.token;
    }
    return token;
}

export function getCurrentUserId() {
    const loginDatas = JSON.parse(localStorage.getItem('loginDatas'));
    return loginDatas?.userId ?? null;
}

export function getCurrentIdentityId() {
    const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));
    return selectedIdentity?.identityId ?? null;
}

export function redirectWithoutLottie(url) {
    localStorage.setItem('disableLottie', 1);
    location.href = url;
}

export function makeRequestWithUserGesture() {
    let promise = document.requestStorageAccess();

    promise.then(
        function () {
            // Storage access was granted.
            console.log('Storage access was granted.');
        },
        function () {
            // Storage access was denied.
            console.log('Storage access was denied.');
        }
    );
}

export function scrollToElement(id, modifier) {
    if (typeof modifier == 'undefined') {
        modifier = 0;
    }

    const element = document.getElementById(id);
    if (element == null) {
        return false;
    }

    element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
}

export function getSystemVersion() {
    if (typeof process.env.VUE_APP_SYSTEM_VERSION != 'undefined' && process.env.VUE_APP_SYSTEM_VERSION != '' && process.env.VUE_APP_SYSTEM_VERSION != null) {
        return process.env.VUE_APP_SYSTEM_VERSION;
    }

    return 'hu';
}

function getAiEnabledValues() {
  const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));
  if (!selectedIdentity || !selectedIdentity.client_aiAssistantEnabled) {
    return [];
  }
  return selectedIdentity.client_aiAssistantEnabled
    .toString()
    .split(',')
    .map(v => v.trim());
}

export function aiChatEnabled() {
  const values = getAiEnabledValues();
  return values.includes("1");
}

export function aiImageEnabled() {
  const values = getAiEnabledValues();
  return values.includes("2");
}

export function setObjectsOrder(list, firstElement) {
  let options = list;
  let array = Object.keys(options).map(key => ({id: key, name: options[key]}));

  array.sort((a, b) => a.name.localeCompare(b.name, 'hu'));

  let index = array.findIndex(option => option.name === firstElement);
  if (index > -1) {
    let searchedOption = array.splice(index, 1)[0];
    array.unshift(searchedOption);
  }

  return array.reduce((obj, item) => (obj[item.id] = item.name, obj) ,{});
}
export function getDataBySystemVersion() {
    let data = {};

    switch (getSystemVersion()) {
        case 'pl':
            data.countryCode = '48';
            data.countryCodeWithPlus = '48';
            data.phoneFullPlaceholder = '123 456 789';
            data.formattedPhoneBrakePoints = [3, 6];
            break;

        case 'hu':
        default:
            data.countryCode = '36';
            data.countryCodeWithPlus = '+36';
            data.phoneFullPlaceholder = '20 666 9999';
            data.formattedPhoneBrakePoints = [2, 5];
            break;
    }

    return data;
}

export function calculateBirthDateFromPersonalNumber(personalNumber, nationalityId) {
    if (getSystemVersion() != 'pl') {
        return false;
    }
    if (nationalityId == undefined || nationalityId == null) {
        nationalityId = false;
    }
    if (nationalityId != 1 && nationalityId != 4040100000002 && nationalityId != 2260100001144) {
        return false;
    }

    if (!isPersonalNumberValid(personalNumber, nationalityId)) {
        return false;
    }

    let digits = ('' + personalNumber).split('');

    let month = parseInt(`${digits[2]}${digits[3]}`);
    let after2000 = (month > 20);
    let yearFirstDigits = (after2000) ? '20' : '19';
    if (after2000) {
        month -= 20;
    }
    let year = `${yearFirstDigits}${digits[0]}${digits[1]}`;
    let day = parseInt(`${digits[4]}${digits[5]}`);
    if (month < 10) {
        month = `0${month}`;
    }
    if (day < 10) {
        day = `0${day}`;
    }
    let date = `${year}-${month}-${day}`;
    return date;
}

export function isPersonalNumberValid(personalNumber, nationalityId) {
    if (nationalityId == undefined || nationalityId == null) {
        nationalityId = false;
    }

    if (nationalityId == 1 || nationalityId == 4040100000002 || nationalityId == 2260100001144) {
        let reg = /^[0-9]{11}$/;

        if(reg.test(personalNumber) == false) {
            return false;
        }

        let digits = ('' + personalNumber).split('');

        if(parseInt(personalNumber.substring( 2, 4)) > 20) {
            if ((parseInt(personalNumber.substring( 4, 6)) > 31)||((parseInt(personalNumber.substring( 2, 4))-20) > 12)) {
                return false;
            }
        } else {
            if ((parseInt(personalNumber.substring( 4, 6)) > 31)||(parseInt(personalNumber.substring( 2, 4)) > 12)) {
                return false;
            }
        }

        let checksum = (1 * parseInt(digits[0]) + 3 * parseInt(digits[1]) + 7 * parseInt(digits[2]) + 9 * parseInt(digits[3]) + 1 * parseInt(digits[4]) + 3 * parseInt(digits[5]) + 7 * parseInt(digits[6]) + 9 * parseInt(digits[7]) + 1 * parseInt(digits[8]) + 3 * parseInt(digits[9])) % 10;
        if (checksum == 0) {
            checksum = 10;
        }

        checksum = 10 - checksum;

        return (parseInt(digits[10]) == checksum);
    } else {
        return true;
    }
}

export function isPolishNationalityId(id) {
    return [4040100000002, 2260100001144, '4040100000002', '2260100001144'].includes(id);
}